import Swiper from 'swiper/swiper-bundle.esm.js'

export default {
	mounted() {
		var swiper = new Swiper(".carouselSlider", {
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + "</span>";
				},
			},
		});

		var imageSwiper = new Swiper(".ImageSwiper", {
			navigation: {
				nextEl: ".image-slider-swiper-button-next",
				prevEl: ".image-slider-swiper-button-prev",
			},
			pagination: {
				el: ".image-slider-swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + "</span>";
				},
			},
		});
	}
}